export default __webpack_public_path__ + "static/media/about_us.ddaa913b.png";